<template>
  <q-page class="q-pa-md" v-if="isReady">

    <div class="text-h5">
      AppMetrica SDK settings
    </div>

    <hr>

    <q-form @submit="saveProperties">
      <q-input label="API Key" v-model="properties.apiKey"/>

      <q-separator/>
      <q-btn type="submit" label="Save" color="primary" class="q-mt-md"/>
    </q-form>

  </q-page>
</template>

<script>

import {integrationsMixin} from "@/pages/workspace/integrations/integrationsMixin";

export default {
  components: {},
  mixins: [integrationsMixin],
  name: "AppMetricaIntegrationSettings",
  data: () => ({
    placement: {},
  }),

  computed: {

    /**
     * Return integration name
     */
    integration: () => ({name: "appmetrica", type: "analytics"}),
  }
}

</script>
